import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Hourglass icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Hourglass } from '@sravni/design-system-icons'
 *
 * <Hourglass />
 * ```
 */
var Hourglass = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Hourglass", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M8.333 15h3.334M14.15 2.5h-8.3a.834.834 0 0 0-.832.833v1.982c0 .35.11.693.316.978L8.018 10l-2.684 3.707a1.667 1.667 0 0 0-.316.978v1.982c0 .46.373.833.833.833h8.297c.46 0 .834-.373.834-.833v-1.952c0-.37-.124-.73-.35-1.022L11.768 10l2.864-3.694c.227-.293.35-.652.35-1.022v-1.95a.834.834 0 0 0-.833-.834v0Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Hourglass };
//# sourceMappingURL=Hourglass.js.map
